export default __webpack_public_path__ + "static/media/TrustWallet.4aa5e525.svg";